<template>
  <van-popup class="confirm-dialog" round v-model="showPopup">
    <div class="confirm-dialog__header">
      <div class="title">接收{{ title }}信息</div>
    </div>
    <div class="confirm-dialog__body">
      <div class="title">请输入手机号或邮箱下单后接受{{ title }}信息</div>
      <input
        type="text"
        class="input"
        placeholder="请输入手机号或邮箱"
        maxlength="50"
        v-model="inputVal"
      >
      <input
        type="text"
        class="input"
        placeholder="请再次输入手机号或邮箱"
        maxlength="50"
        v-model="confirmVal"
      >
      <div class="tips">如输入错误号码造成{{ title }}泄露平台概不负责</div>
    </div>
    <div class="confirm-dialog__footer">
      <div class="btn" @click="cancel">取消</div>
      <div class="btn confirm" @click="confirm">确认</div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: "confirmMobileOrEmail",
  data() {
    return {
      showPopup: false,
      inputVal: '',
      confirmVal: '',
    }
  },
  props: {
    type: {
      type: Number,
      default: 1,
    }
  },
  computed: {
    title() {
      const map = {
        1: '卡密',
        2: '卡券',
      }
      return map[this.type];
    }
  },
  components: {},
  watch: {},
  methods: {
    clearData() {
      this.inputVal = '';
      this.confirmVal = '';
    },
    cancel() {
      this.clearData()
      this.showPopup = false;
    },
    openDialog() {
      this.showPopup = true
    },
    confirm() {
      const emailExp = /^[^\u4e00-\u9fa5\s]+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,8})$/
      const phoneExp = /^1\d{10}$/;
      //
      const valid = (emailExp.test(this.inputVal) || phoneExp.test(this.inputVal)) &&
        (emailExp.test(this.confirmVal) || phoneExp.test(this.confirmVal))

      if (!valid) {
        this.$toast('输入格式不正确');
        return
      }
      if (this.inputVal !== this.confirmVal) {
        this.$toast('两次输入结果不一致');
        return
      }
      const result = this.inputVal
      this.clearData()
      this.showPopup = false;
      this.$emit('getResult', result);
    },
  },
  created() {
  },
}
</script>

<style lang="scss" scoped>
.confirm-dialog {
  width: 6rem;

  &__header {
    display: flex;
    font-size: 0.32rem;
    height: .98rem;
    justify-content: center;
    align-items: center;
    box-shadow: 0 1px 0 0 rgba(230, 230, 230, 1);

    .title {
      font-weight: 400;
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    margin: .32rem .46rem;

    > .title {
      font-size: .24rem;
      color: #787878;
    }

    > .input {
      display: block;
      width: 100%;
      height: .72rem;
      background: #FFFFFF;
      border: .02rem solid #CCCCCC;
      font-size: .24rem;
      border-radius: .08rem;
      margin: .16rem 0;
      padding-left: .16rem;
      box-sizing: border-box;
    }

    > .tips {
      font-size: .2rem;
      color: #F29254;
      margin-bottom: .32rem;
    }
  }

  &__footer {
    display: flex;
    height: .97rem;
    line-height: .97rem;
    border-top: .02rem solid #E6E6E6;

    > .btn {
      flex: 1;
      text-align: center;
      font-size: .32rem;
      color: #383838;

      &:first-child {
        border-right: .02rem solid #E6E6E6;
      }

      &.confirm {
        color: #3399FF;
      }
    }
  }
}
</style>
